import { UrlServices } from "./common/UrlServices";

export const environment = {
  production: true,
  version: "1.0.3",
  JSONFOL: "assets/json",
  SoliUrl: "https://www.solidaria.com.co/WALeasing/soliarriendo",
  LinkUrl: "https://seguros.likesolidaria.com.co/soliarriendo/",
  UrlServices: {
      API_Leasing: "https://www.solidaria.com.co/ApiGatewaySolidaria/APILeasing",
      API_DigitalClient: "https://www.solidaria.com.co/ApiGatewaySolidaria/APIDigitalClient",
      API_Firma: "https://www.solidaria.com.co/ApiGatewaySolidaria/APIFirmaElectronica"
  } as UrlServices,
  KEY: "1ZE6C9XJHGXLfSFqrzAvnrcMBkzJA8VxvAyOuVr7HMQ="
};
